import currencyFormatter from 'currency-formatter'

// https://www.npmjs.com/package/currency-formatter
// set the format so we see currency code after the formatted number. Only allows for the currency code option
function money (number, code) {
  return currencyFormatter.format(number, { symbol: code, format: '%v %s' })
}

// gets the actual symbol of a currency code (i.e. USD -> $)
function currencySymbol (opt) {
  return currencyFormatter.findCurrency(opt).symbol
}

function MoneyPlugin (Vue) {
  Vue.prototype.$money = money
  Vue.prototype.$currencySymbol = currencySymbol
}

export { MoneyPlugin }
